import {RestResource} from '../rest'
import {DCIM_SERVER} from "../server";

const location = new RestResource({server: DCIM_SERVER, resource: 'location'});

location.getLocationsByIds = async (ids) => {
    let locations = [];
    if (ids != null && ids.length > 0) {
        let response = await location.list({in_id: ids});
        if (response.status === 200 && String(response.data.code) === '200') {
            locations = response.data.data;
        } else {
            console.error(response.data.message);
        }
    }
    return locations;
};

export default location;
